import {Outlet} from "react-router-dom";

function CreateDesign() {
    return (
        <Outlet/>
    )
}

export default CreateDesign;